import {
  BTypeBreadCrumb,
  ClickEventType,
  FUNERAL_SIDO,
  FUNERAL_SIGUNGU,
  GOI_WEB_URL,
  ParlorDetailProps,
} from "goi_common";

interface BreadCrumbProps {
  defaultParlor: ParlorDetailProps;
  event: Pick<ClickEventType, "path">;
}

export const BreadCrumb = ({ defaultParlor, event }: BreadCrumbProps) => {
  return (
    <BTypeBreadCrumb
      firstItem={{
        text: `장례식장 추천`,
        href: `${GOI_WEB_URL}?utm_source=dogsound` + "/match/request/?utm_source=dogsound",
        event: {
          domain: "dggb",
          path: event.path,
          trigger_and_target: "br_crumb_mth_req",
        },
      }}
      secondItem={{
        text: `${FUNERAL_SIDO.get(Number(defaultParlor.sido))} 장례식장`,
        href: `/price/${defaultParlor.sido}/`,
        event: {
          domain: "dggb",
          path: event.path,
          trigger_and_target: "br_crumb_sido_prlr_list",
        },
      }}
      thirdItem={{
        text: `${FUNERAL_SIGUNGU.get(Number(defaultParlor.sido))?.get(
          Number(defaultParlor.sigungu)
        )} 장례식장`,
        href: `/price/${defaultParlor.sido}-${defaultParlor.sigungu}/`,
        event: {
          domain: "dggb",
          path: event.path,
          trigger_and_target: "br_crumb_sigungu_prlr_list",
        },
      }}
      goiHomeEvent={{
        domain: "dggb",
        path: event.path,
        trigger_and_target: "br_crumb_goi_home",
      }}
    />
  );
};
